const CLOUDFRONT_URL = process.env.VUE_APP_CLOUDFRONT_URL || 'https://assets.rebajatuscuentas.com';

export default {
  COUNTRY_CODE: 'pe',

  /** External URLs */
  API_URL: process.env.VUE_APP_API_URL,
  CLOUDFRONT_URL,
  USER_ACCOUNT_URL: 'https://rebajatuscuentas.com/pe/usuario',
  WEBSITE_URL: 'https://rebajatuscuentas.com/pe',
  BLOG_URL: 'https://rebajatuscuentas.com/pe/blog',

  /** Assets */
  COMPANY_LOGO: CLOUDFRONT_URL + '/logos/rebaja_tus_cuentas.svg',
  COMPANY_LOGO_WHITE: CLOUDFRONT_URL + '/logos/rebaja_tus_cuentas_white.svg',

  /** Third party  */
  RAVEN_DSN: process.env.VUE_APP_RAVEN_DSN,
  SENTRY_ENVIRONMENT: process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production',
  HOTJAR_ID: process.env.VUE_APP_HOTJAR_ID,

  DEFAULT_ADVISER: {
    avatar: CLOUDFRONT_URL + '/images/advisers/Nicolas.jpg',
    name: 'Nicolás',
    id: undefined,
  },

  CURRENCIES: [],

  INSURANCE_TYPES: [
    { text: 'Mancomunado', value: 1 },
    { text: 'Individual', value: 2 },
    { text: 'Endosado', value: 3 },
  ],

  /** Accounting */
  MONEY_SYMBOL: process.env.VUE_APP_MONEY_SYMBOL || 'S/',
  MONEY_FORMAT: process.env.VUE_APP_MONEY_FORMAT || '%s %v',
  NUMBER_DECIMAL: process.env.VUE_APP_NUMBER_DECIMAL || '.',
  NUMBER_THOUSAND: process.env.VUE_APP_NUMBER_THOUSAND || ',',
};
